function Api(method, path){
    let api = new Object
    api.method = method;
    api.path = path;
    api.permit = function(){
        return this.method + '@' + api.path
    };
    return api;
}
module.exports = {
    _js_sdk_config: Api('get','/wx/official/js_sdk_config'),
    _pre_authorization_url: Api('get','/wx/official/pre_authorization_url'),
    _official_login: Api('post','/wx/official/login'),
    _get_user_info: Api('get','/user/info'),
    _get_sys_config: Api('get','/sys/config'),
    _wx_payment_index: Api('get','/wx/payment/index'),
    _wx_payment_pay: Api('post','/wx/payment/pay'),
    _device_upload_image: Api('post','/file/upload_image'),
    _device_index: Api('get','/device/index'),
    _device_maintenance: Api('get','/device/maintenance'),
    _device_detail: Api('get','/device/detail'),
    _device_bind: Api('post','/device/bind'),
    _device_set: Api('post','/device/set'),
    _device_batch_set: Api('post','/device/batch_set'),
    _device_batch_relocation: Api('post','/device/batch_relocation'),
    _device_del: Api('post','/device/del'),
    _alarm_index: Api('get','/alarm/index'),
    _consumption_index: Api('get','/consumption/index'),
}
